(function($) {

	$(document).ready(function() {

		$('body').on('click', '[data-event=remove-layout]', function(e) {
			return confirm('Delete widget?');
		});
	});

})(jQuery);